<template>
  <div>    
    <iframe allowtransparency id="iframe-component" style="height:100%;width:100%;margin:0;border:none" :src="srcUrl"></iframe>
  </div>
</template>

<script>
export default {
  props:{
    srcUrl:{
      type: String,
      required:true
    }
  },
  watch:{
    srcUrl(v){
      console.log('src',v);
    }
  },
  mounted(){
    document.getElementById('iframe-component').onload = () => {
        console.log('iframe-loaded');
        this.$emit('onLoad')
    }
  }
}
</script>

<style>

</style>